var DEFAULT_COL_MIN_WIDTH = 150;
export var getColumnsGroupByCustomHeader = function (columns, customHeaders) {
    var groupIndex = 1;
    var currentGroup = null;
    var currentTitle = '';
    var groupedColumns = {};
    var customGroups = new Map();
    customHeaders.forEach(function (group) {
        Array.from({ length: group.toIndex - group.fromIndex + 1 }).forEach(function (_, i) {
            customGroups.set(group.fromIndex + i, group.title);
        });
    });
    columns.slice(1).forEach(function (col, index) {
        var actualIndex = index + 1;
        var title = customGroups.get(actualIndex) || '';
        if (title !== currentTitle || !currentGroup) {
            currentGroup = "column".concat(groupIndex);
            groupIndex += 1;
            groupedColumns[currentGroup] = { title: title, columns: [] };
            currentTitle = title;
        }
        if (!groupedColumns[currentGroup]) {
            groupedColumns[currentGroup] = { title: title, columns: [] };
        }
        groupedColumns[currentGroup].columns.push(col);
    });
    return groupedColumns;
};
export var getCustomHeaderGridTemplate = function (columnsGroupByCustomHeader) {
    return Object.entries(columnsGroupByCustomHeader)
        .map(function (_a) {
        var value = _a[1];
        var sumOfMinWidth = value.columns.filter(function (column) { return !column.hidden; }).reduce(function (sum, column) { return sum + (column.minWidth || DEFAULT_COL_MIN_WIDTH); }, 0);
        return "".concat(sumOfMinWidth, "fr");
    })
        .join(' ');
};
export var getRowMinWidth = function (columns) {
    return columns.filter(function (column) { return !column.hidden; }).reduce(function (sum, column) { return sum + (column.minWidth || DEFAULT_COL_MIN_WIDTH); }, 0);
};
export var getFirstColumnMinWidth = function (firstColumn) { return firstColumn.minWidth || DEFAULT_COL_MIN_WIDTH; };
export var getColumnGridTemplate = function (columns) {
    return columns
        .filter(function (column) { return !column.hidden; })
        .map(function (column) { return "".concat(getFirstColumnMinWidth(column), "fr"); })
        .join(' ');
};
export var getHeaderScrollableGTC = function (columns) { return getColumnGridTemplate(columns.slice(1)); };
